/**
 * @generated SignedSource<<6704398c908cba19d4e7334b23250a41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationListItem_notification$data = {
  readonly advertiserName: string | null;
  readonly campaignTitle: string | null;
  readonly createdAt: any;
  readonly id: string;
  readonly influencerName: string | null;
  readonly message: string | null;
  readonly messagePreview: string | null;
  readonly pushCampaignMessage: {
    readonly title: string;
  } | null;
  readonly seen: boolean | null;
  readonly url: string | null;
  readonly urlText: string | null;
  readonly " $fragmentType": "NotificationListItem_notification";
};
export type NotificationListItem_notification$key = {
  readonly " $data"?: NotificationListItem_notification$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationListItem_notification">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationListItem_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messagePreview",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "influencerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seen",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "campaignTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "advertiserName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PushCampaignMessage",
      "kind": "LinkedField",
      "name": "pushCampaignMessage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Notification",
  "abstractKey": null
};

(node as any).hash = "5e6ce21848325d5245cb8e635c80a016";

export default node;
